import { useMedia, useMediaLayout } from 'use-media';
import breakpoints from '../presets/mq.json.js';

const BREAKPOINTS = {
  mobile: breakpoints['--mobile'],
  tablet: breakpoints['--tablet'],
  desktop: breakpoints['--desktop']
};

// todo: Move useIsServer to own hook.js. Tests currently break if useIsServer is imported
function useIsServer() {
  return typeof window === 'undefined' || typeof document === 'undefined';
}
const useBreakpoint = (fallback = 'desktop') => {
  const isServer = useIsServer();
  const effect = isServer ? useMedia : useMediaLayout;
  const isMobile = effect(BREAKPOINTS.mobile);
  const isTablet = effect(BREAKPOINTS.tablet);
  const isDesktop = effect(BREAKPOINTS.desktop);
  if (isMobile) return 'mobile';
  if (isTablet) return 'tablet';
  if (isDesktop) return 'desktop';
  return fallback;
};

export { useBreakpoint };
